<template>
    <div class="certificate">
        <h4>{{ $t('certificate.TITLE') }}</h4>

        <div class="certificate-carousel-options">
            <div class="certificate-carousel-options--add">
                <button class="create-new" @click="showCertificateModal = true">
                    <i class="material-icons">add_circle</i>{{ $t('certificate.NEW_CERTIFICATE') }}
                </button>
            </div>
        </div>
        <div class="certificate-carousel">
            <div class="certificate-carousel__cards" v-if="!templatesLoading">
                
                <div class="certificate-carousel__card certificate-carousel__card--arrow" @click="prevPageTemplates" v-if="hasBackResultsTemplates">
                    <div class="certificate-carousel__card--arrow__icon">
                        <i class="material-icons">keyboard_arrow_left</i>
                    </div>
                </div>
    
                <div class="certificate-carousel__cards-container">
                    <div class="certificate-carousel__card"
                    v-for="template in templates" :key="template.id"
                    @click="selectedTemplate = template"
                    >
                        <div class="certificate-carousel__card__check"
                        :class="{ 'selected': selectedTemplate.id === template.id }"
                        >
                            <div class="check-icon">
                                <i class="material-icons">check</i>
                            </div>
                        </div>
                        <div class="certificate-carousel__card__preview">
                            <div class="certificate-carousel__card__preview__bg" :style="{ backgroundImage: `url(${template.bodyFileName})` }"></div>
                            <div class="certificate-carousel__card__preview__top" :style="{ backgroundImage: `url(${template.layoutExampleImage})` }"></div>
                        </div>
                        <div class="certificate-carousel__card__title">{{ template.name }}</div>
                    </div>
                </div>
    
                <div class="certificate-carousel__card certificate-carousel__card--arrow" @click="nextPageTemplates" v-if="hasMoreResultsTemplates">
                    <div class="certificate-carousel__card--arrow__icon">
                        <i class="material-icons">keyboard_arrow_right</i>
                    </div>
                </div>
                
            </div>
    
            <div v-else class="certificate-loader">
                <Loader/>
            </div>
        
        </div>
    
        <div class="certificate-preview">
            <h4>{{ $t('certificate.PREVIEW') }}</h4>
            <div class="certificate-preview__preview">
                <div class="certificate-preview__preview__bg"
                :style="{ backgroundImage: `url(${selectedTemplate?.bodyFileName})` }"></div>
                <div class="certificate-preview__preview__top"
                :style="{ backgroundImage: `url(${selectedTemplate?.layoutExampleImage})` }"></div>
            </div>
            <div v-if="selectedTemplate" class="certificate-preview__title">{{ selectedTemplate?.name }}</div>
        </div>
    
        <Modal :isOpen="showCertificateModal" @close="handleModalClose()">
            <template v-if="!modalCancelling">
                <h4>{{ $t('certificate.NEW_CERTIFICATE') }}</h4>
                <EmptyState icon="error" :title="$t('certificate.ERROR_OCCURRED')" color="pink" v-if="generalError" />
                <div class="add-certificate-modal" v-else>
                    <div class="file-uploading" v-if="certificateModel.fileUploading">
                        <Loader/>
                    </div>
    
                    <div class="modal-cols">
                        <div class="modal-cols__col modal-cols__col--options">
    
                            <div class="modal-cols__col__box modal-cols__col__box--name">
                                <h3>{{ $t('certificate.NAME') }}</h3>
                                <p>
                                {{ $t('certificate.ENTER_NAME') }}
                                </p>

                                <Input
                                v-model="certificateModel.name"
                                type="text"
                                placeholder="Ejemplo: MEX-TMT-23-01 "
                                label="Nombre del certificado"
                                :isError="existingNameError"
                                errorMessage="Ya existe un certificado con ese nombre, por favor regresa al selector de certificados para seleccionarlo"
                                @input="resetNameError"
                                />

                            </div>
    
    
                            <div class="modal-cols__col__box modal-cols__col__box--layout">
                                <h3>{{ $t('certificate.STYLE') }}</h3>
                                <p>
                                {{ $t('certificate.CHOOSE_STYLE') }}
                                </p>

                                <div class="add-certificate-modal__select-alignment" v-if="!layoutsLoading">
    
                                    <div @click="prevPageLayouts" v-if="hasBackResultsLayouts" class="add-certificate-modal__select-alignment__arrow add-certificate-modal__select-alignment__arrow--back">
                                        <i class="material-icons">keyboard_arrow_left</i>
                                    </div>                                
                                    <div v-for="layout in layouts" :key="layout.id">
                                        <div class="alignment-option" @click="selectLayout(layout)" :class="{ 'selected': selectedLayout === layout }">
                                            <div class="alignment-option__card__check"
                                            :class="{ 'selected': selectedLayout === layout }"
                                            >
                                                <div class="check-icon" v-if="selectedLayout === layout">
                                                    <i class="material-icons">check</i>
                                                </div>
                                            </div>
                                            <div class="alignment-option__icon">
                                                <img :src="layout.icon">
                                            </div>
                                        </div>
                                    </div>
                                    <div @click="nextPageLayouts" v-if="hasMoreResultsLayouts" class="add-certificate-modal__select-alignment__arrow add-certificate-modal__select-alignment__arrow--next">
                                        <i class="material-icons">keyboard_arrow_right</i>
                                    </div>
                                    
                                </div>
                                <div v-else class="layouts-loader">
                                    <Loader/>
                                </div>
                            </div>
    
                            <div class="modal-cols__col__box modal-cols__col__box--image">
                                <h3>DISEÑO</h3>
                                <h3>{{ $t('certificate.DESIGN') }}</h3>
                                <p>
                                {{ $t('certificate.CHOOSE_DESIGN') }}
                                </p>

                                <div class="upload-file__container">
                                    <label :class="{ 'disabled': certificateModel.fileUploading || certificateModel.file && imageMeetsRequirements }"
                                    for="upload-file">
                                    {{ !certificateModel.fileUploading ? $t('certificate.UPLOAD_IMAGE') : $t('certificate.UPLOADING_FILE') }}
                                    <i class="material-icons">file_upload</i>
                                    </label>

                                    <input ref="fileInput" :disabled="certificateModel.fileUploading || certificateModel.file && imageMeetsRequirements" type="file" accept=".png" id="upload-file" @change="handleFileChange">
                                </div>
    
                                <div
                                class="uploaded-file__pill"
                                :class="{ 'requirements-not-met': !imageMeetsRequirements }"
                                v-if="certificateModel.file">
                                    <span>{{ certificateModel.file.name }}</span>
                                    <i class="material-icons" @click="removeFile">close</i>
                                </div>
    
                                <div class="add-certificate-modal__certificate-instructions">
                                    <i class="material-icons" :class="{ error: uploadError }">{{ uploadError ? 'cancel' : 'info' }}</i>
                                    <p :class="{ error: uploadError }">
                                    {{ uploadError || $t('certificate.IMAGE_REQUIREMENTS', { width: selectedLayout?.width, height: selectedLayout?.height }) }}
                                    </p>
                                </div>
                            </div>
                        </div>
        
                        <div class="modal-cols__col modal-cols__col--preview">
                            <EmptyState
                            v-if="!certificateModel.file || uploadError"
                            icon="preview" :title="$t('certificate.PREVIEW_INFO')"/>

                            <div
                            v-else
                            class="certificate-preview">
                                <div class="certificate-preview__preview">
                                    <div class="certificate-preview__preview__bg"
                                    :style="{ backgroundImage: certificateModel.filePreview ? `url(${certificateModel.filePreview})` : null }"></div>
                                    <div class="certificate-preview__preview__top"
                                    :style="{ backgroundImage: selectedLayout ? `url(${selectedLayout.exampleImage})` : null }"></div>
                                </div>
                            </div>
                        </div>
                    </div>
        
                    <div class="modal__buttons">
                        <button class="cancel" @click="handleModalClose()">{{ $t('global.CANCEL') }}</button>
                        <button class="confirm" @click="saveCertificateTemplate" :disabled="uploadError || !certificateModel.name || !selectedLayout || existingNameError || !imageMeetsRequirements || certificateModel.fileUploading || !certificateModel.file"
                        :style="{ opacity:  uploadError || !certificateModel.name || !selectedLayout || existingNameError || !imageMeetsRequirements || certificateModel.fileUploading || !certificateModel.file ? 0.2 : 1 }">{{ $t('global.SAVE') }}</button>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="modal-you-sure">
                    <h4 v-html="$t('certificate.CONFIRM_CANCEL_TITLE')"></h4>
                    <p>{{ $t('certificate.CONFIRM_CANCEL_TEXT') }}</p>

                    <div class="modal__buttons">
                        <button class="cancel" @click="modalCancelling = false" style="border:none;">{{ $t('certificate.NO_GO_BACK') }}</button>
                        <button class="confirm" @click="showCertificateModal = false; clearModalFields(); modalCancelling = false">{{ $t('certificate.YES_CANCEL') }}</button>
                    </div>
                </div>
            </template>
        </Modal>
    </div>
</template>

<script>
import { ref, onMounted, watch, computed } from 'vue';
import { useStore } from 'vuex';
import Loader from '@/components/Loader.vue';
import EmptyState from '@/components/EmptyState.vue';
import Input from '@/components/Input.vue';
import Modal from '@/components/Modal.vue';
import { useI18n } from 'vue-i18n';


export default {
    components: {
        Modal,
        Input,
        Loader,
        EmptyState
    },
    props: {
        certificateId: {
            type: Number,
            default: null
        },
        certificateType: {
            type: String,
            default: 'default'
        }
    },
    setup(props, { emit }) {
        const { t } = useI18n();
        const store = useStore();
        const templates = ref([]);
        const templatesLoading = ref(false);
        const selectedTemplate = ref(null);
        const layouts = ref([]);
        const layoutsLoading = ref(false);
        const selectedLayout = ref(null);
        const pageNumberTemplates = ref(0);
        const rowsPerPageTemplates = ref(4);
        const pageNumberLayouts = ref(0);
        const rowsPerPageLayouts = ref(2);
        const totalResultsTemplates = ref(0);
        const totalResultsLayouts = ref(0);
        const showCertificateModal = ref(false);
        const modalCancelling = ref(false);
        const existingNameError = ref(false);
        const certificateModel = ref({
            name: '',
            file: null,
            filePreview: '',
            alignment: 'left',
            fileUploading: false
        });
        const fileInput = ref(null);
        const uploadError = ref('');

        const imageMeetsRequirements = ref(false);

        const generalError = ref(false);

        watch(selectedTemplate, (newVal) => {
            emit('update:certificateId', newVal?.id || null);
            emit('update:certificateType', newVal.name || 'default');
        });


        function resetNameError() {
            existingNameError.value = false;
        }

        function clearModalFields() {
            certificateModel.value = {
                name: '',
                file: null,
                filePreview: '',
                alignment: 'left',
                fileUploading: false
            };
            uploadError.value = '';
            existingNameError.value = false;
        }

        function handleModalClose() {
            if(certificateModel.value.name || certificateModel.value.file) {
                modalCancelling.value = true;
            } else {
                showCertificateModal.value = false;
                clearModalFields();
                modalCancelling.value = false;
            }
        }


        async function getTemplates() {
            templatesLoading.value = true;
            try {
                let req = await store.dispatch('preInscription_getCertificateTemplates', {
                    pageNumber: pageNumberTemplates.value,
                    rowsPerPage: rowsPerPageTemplates.value
                });
                templates.value = req.data.data;
                totalResultsTemplates.value = req.data.totalResults;

                templates.value.forEach(template => {
                    template.bodyFileName = `${process.env.VUE_APP_CERTIFICATES_TEMPLATES}${template.bodyFileName}`;
                });
                templates.value.forEach(template => {
                    template.layoutExampleImage = `${process.env.VUE_APP_CERTIFICATES_LAYOUTS}${template.layoutExampleImage}`;
                });

                if (!selectedTemplate.value) {
                    if (pageNumberTemplates.value === 0) {
                    selectedTemplate.value = templates.value.find(template => template.isDefault);
                    }
                }
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: 'Error al cargar los templates' });
            } finally {
                templatesLoading.value = false;
            }
        }

        async function getLayouts() {
            layoutsLoading.value = true;
            try {
                let req = await store.dispatch('preInscription_getCertificateLayouts', {
                    pageNumber: pageNumberLayouts.value,
                    rowsPerPage: rowsPerPageLayouts.value
                });
                layouts.value = req.data.data;
                totalResultsLayouts.value = req.data.totalResults;

                layouts.value.forEach(layout => {
                    layout.icon = `${process.env.VUE_APP_CERTIFICATES_LAYOUTS_ICONS}${layout.icon}`;
                });

                layouts.value.forEach(layout => {
                    layout.exampleImage = `${process.env.VUE_APP_CERTIFICATES_LAYOUTS}${layout.exampleImage}`;
                });

                if (pageNumberLayouts.value === 0) {
                    selectedLayout.value = layouts.value.find(layout => layout.isDefault);
                }
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: 'Error al cargar los layouts' });
            } finally {
                layoutsLoading.value = false;
            }
        }

        const nextPageTemplates = () => {
            if ((pageNumberTemplates.value + 1) * rowsPerPageTemplates.value < totalResultsTemplates.value) {
                pageNumberTemplates.value++;
                getTemplates();
            }
        };

        const prevPageTemplates = () => {
            if (pageNumberTemplates.value > 0) {
                pageNumberTemplates.value--;
                getTemplates();
            }
        };

        const nextPageLayouts = () => {
            if ((pageNumberLayouts.value + 1) * rowsPerPageLayouts.value < totalResultsLayouts.value) {
                pageNumberLayouts.value++;
                getLayouts();
            }
        };

        const prevPageLayouts = () => {
            if (pageNumberLayouts.value > 0) {
                pageNumberLayouts.value--;
                getLayouts();
            }
        };

        const hasMoreResultsTemplates = computed(() => {
            return (pageNumberTemplates.value + 1) * rowsPerPageTemplates.value < totalResultsTemplates.value;
        });

        const hasBackResultsTemplates = computed(() => {
            return pageNumberTemplates.value > 0;
        });

        const hasMoreResultsLayouts = computed(() => {
            return (pageNumberLayouts.value + 1) * rowsPerPageLayouts.value < totalResultsLayouts.value;
        });

        const hasBackResultsLayouts = computed(() => {
            return pageNumberLayouts.value > 0;
        });

        function handleFileChange(event) {
            const file = event.target.files[0];
            if (!file) return;

            const img = new Image();
            const reader = new FileReader();
            reader.onload = (e) => {
                img.src = e.target.result;
                img.onload = () => {
                    if (file.type !== 'image/png') {
                        uploadError.value = `Formato incorrecto. Formato: PNG. Tamaño mínimo: ${selectedLayout.value.width}x${selectedLayout.value.height} px`;
                        imageMeetsRequirements.value = false;
                        return;
                    }

                    certificateModel.value.file = file;
                    certificateModel.value.filePreview = URL.createObjectURL(file);

                    if (certificateModel.value.file) {
                        const img = new Image();
                        img.src = certificateModel.value.filePreview;
                        img.onload = () => {
                            if (img.width !== selectedLayout.value.width || img.height !== selectedLayout.value.height) {
                                uploadError.value = `Tamaño insuficiente. Formato: PNG. Tamaño mínimo: ${selectedLayout.value.width}x${selectedLayout.value.height} px`;
                                imageMeetsRequirements.value = false;
                            } else {
                                uploadError.value = '';
                                imageMeetsRequirements.value = true;
                            }
                        };
                    }

                    if (img.width !== selectedLayout.value.width || img.height !== selectedLayout.value.height) {
                        uploadError.value = `Tamaño insuficiente. Formato: PNG. Tamaño mínimo: ${selectedLayout.value.width}x${selectedLayout.value.height} px`;
                        imageMeetsRequirements.value = false;
                    } else {
                        uploadError.value = '';
                        imageMeetsRequirements.value = true;
                    }
                };
            };
            reader.readAsDataURL(file);
        }

        function selectLayout(layout) {
            selectedLayout.value = layout;
            if (certificateModel.value.file) {
                const img = new Image();
                img.src = certificateModel.value.filePreview;
                img.onload = () => {
                    if (img.width !== layout.width || img.height !== layout.height) {
                        uploadError.value = `Tamaño insuficiente. Formato: PNG. Tamaño mínimo: ${layout.width}x${layout.height} px`;
                        imageMeetsRequirements.value = false;
                    } else {
                        uploadError.value = '';
                        imageMeetsRequirements.value = true;
                    }
                };
            }
        }

        function removeFile() {
            certificateModel.value.file = null;
            certificateModel.value.filePreview = '';
            uploadError.value = '';
            fileInput.value.value = '';
            imageMeetsRequirements.value = false;
        }

        const savedCertificateName = ref(null);

        const newSavedCertificate = ref(null);

        async function saveCertificateTemplate() {
            if (!certificateModel.value.name || !certificateModel.value.file) {
                store.dispatch('notifications_create', { text: 'Por favor, complete todos los campos' });
                return;
            }

            try {
                certificateModel.value.fileUploading = true;

                let formData = new FormData();
                formData.append('file', certificateModel.value.file);
                formData.append('name', certificateModel.value.name);

                await store.dispatch('preInscription_checkCertificateTemplateName', { name: certificateModel.value.name });

                let req = await store.dispatch('stuff_saveCertificateTemplate', formData);
                const fileName = req.data.fileName;

                let reqCert = await store.dispatch('preInscription_createCertificateTemplate', { name: certificateModel.value.name, file: fileName, layoutId: selectedLayout.value.id });
                newSavedCertificate.value = reqCert.data;
                newSavedCertificate.value.bodyFileName = `${process.env.VUE_APP_CERTIFICATES_TEMPLATES}${newSavedCertificate.value.bodyFileName}`;
                newSavedCertificate.value.layoutExampleImage = `${process.env.VUE_APP_CERTIFICATES_LAYOUTS}${newSavedCertificate.value.layoutExampleImage}`;

                templates.value.splice(1, 0, newSavedCertificate.value);
                if (templates.value.length > 4) {
                    templates.value.pop();
                }
                selectedTemplate.value = newSavedCertificate.value;
                savedCertificateName.value = certificateModel.value.name;
                certificateModel.value = {
                    name: '',
                    file: null,
                    filePreview: '',
                    alignment: 'left',
                    fileUploading: false
                };
                showCertificateModal.value = false;

                certificateModel.value.fileUploading = false;

                store.dispatch('notifications_create', { text: 'Certificado guardado con éxito.' });

            } catch (error) {
                console.log(error);
                if (error.response.data === 'ALREADY_EXIST_CERTIFICATE_TEMPLATE') {
                    existingNameError.value = true;
                } else {
                    store.dispatch('notifications_create', { text: 'Error al guardar el certificado' });
                    generalError.value = true;
                }
                certificateModel.value.fileUploading = false;
            }
        }



        onMounted(() => {
            getTemplates();
            getLayouts();
        });

        return {
            templates,
            templatesLoading,
            layouts,
            layoutsLoading,
            pageNumberTemplates,
            rowsPerPageTemplates,
            pageNumberLayouts,
            rowsPerPageLayouts,
            totalResultsTemplates,
            totalResultsLayouts,
            showCertificateModal,
            existingNameError,
            certificateModel,
            fileInput,
            getTemplates,
            nextPageTemplates,
            prevPageTemplates,
            nextPageLayouts,
            prevPageLayouts,
            hasMoreResultsTemplates,
            hasBackResultsTemplates,
            hasMoreResultsLayouts,
            hasBackResultsLayouts,
            handleFileChange,
            selectLayout,
            removeFile,
            saveCertificateTemplate,
            selectedTemplate,
            selectedLayout,
            imageMeetsRequirements,
            uploadError,
            savedCertificateName,
            newSavedCertificate,
            generalError,
            resetNameError,
            clearModalFields,
            modalCancelling,
            handleModalClose,
            t
        };
    }
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';



.certificate {
    display: flex;
    flex-direction: column;
    gap: 16px;

    > h4 {
        font-weight: 700;
        font-size: 13px;    
    }
}

.certificate-carousel-options {
    display: flex;
    justify-content: flex-end;

    &--add {
        .create-new {
            display: inline-flex;
            gap: 8px;
            align-items: center;
            color: $green;
            font-weight: 600;
            font-size: 14px;

            i {
                font-size: 14px;
            }
        }
    }

}

.certificate-carousel {
    position: relative;
    width: 100%;
    height: 100%;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.10);
    border-radius: 10px;
    overflow: hidden;

    &__cards {
        display: flex;
        gap: 10px;
        justify-content: space-between;
        padding: 10px;
        justify-content: flex-start;
    }

    .certificate-loader {
        width: 100%;
        height: 140px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__cards-container {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 10px;
        width: 100%;
    }

    &__card {
        position: relative;
        cursor: pointer;

        &--arrow {
            font-size: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 24px;

            &__icon {
                cursor: pointer;
                color: $green;
            }
        }

        &__check {
            position: absolute;
            background-color: #fff;
            top: 10px;
            right: 10px;
            z-index: 1;
            border: 1px solid $green;
            width: 15px;
            height: 15px;
            border-radius: 2px;
            display: flex;
            align-items: center;
            justify-content: center;

            .check-icon {
                display: none;
            }

            &.selected {
                background-color: $green;

                .check-icon {
                    display: block;
                    i {
                        display: block;
                        color: #fff;
                        font-size: 13px;
                    }
                }
            }

        }

        &__preview {
            position: relative;
            background-color: #fff;
            overflow: hidden;
            aspect-ratio: 1.6;

            &__bg {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
            }
    
            &__top {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
            }
        }

        &__title {
            font-weight: 700;
            font-size: 10px;
            text-align: center;
            padding: 6px;
        }
    }
}

.certificate-preview {
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.10);
    border-radius: 10px;
    padding: 16px;

    h4 {
        font-weight: 700;
        font-size: 13px;
        margin-bottom: 16px;
    }


    &__preview {
        position: relative;
        width: 100%;
        border-radius: 10px;
        overflow: hidden;
        aspect-ratio: 1.6;

        &__bg {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
        }
    
        &__top {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
        }
    }

    &__title {
        font-weight: 700;
        font-size: 13px;
        text-align: center;
        padding: 12px;
    }
}

.add-certificate-modal {
    display: flex;
    flex-direction: column;
    width: 932px;
    position: relative;

    .file-uploading {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background: rgba(255, 255, 255, 0.7);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .modal-cols {
        display: flex;
        gap: 24px;
        
        &__col {
            display: flex;
            flex-direction: column;
            gap: 10px;

            &--options {
                width: 290px;
                flex-shrink: 0;
            }

            &--preview {
                width: 100%;

                & .emptyState {
                    height: 100%;
                }
            }

            &__box {
                box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.10);
                padding: 10px;
                border-radius: 10px;
                display: flex;
                flex-direction: column;
                gap: 10px;

                h3 {
                    font-size: 13px;
                    font-weight: 700;
                }

                p {
                    font-size: 11px;
                    font-weight: 600;
                }

                &--layout {
                    .layouts-loader {
                        width: 100%;
                        height: 80px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }
            }
        }
    }

    &__select-alignment {
        display: flex;
        align-items: center;
        gap: 10px;

        p {
            font-size: 14px;
        }

        &__arrow {
            color: $green;
        }

        .alignment-option {
            display: flex;
            flex-direction: column;
            gap: 10px;
            cursor: pointer;
            border: 1px solid #C4C4C4;
            color: #C4C4C4;
            border-radius: 10px;
            flex: 1 1 33%;
            position: relative;
            
            &__icon {
                font-size: 40px;
                width: 80px;
                height: 80px;
                display: flex;
                align-items: center;
                justify-content: center;

                i {
                    font-size: 40px;
                }
            }
            
            &__label {
                font-size: 14px;
            }

            &__card__check {
                position: absolute;
                background-color: #fff;
                top: 4px;
                right: 4px;
                z-index: 1;
                border: 1px solid $green;
                width: 15px;
                height: 15px;
                border-radius: 2px;
                display: flex;
                align-items: center;
                justify-content: center;

                .check-icon {
                    display: none;
                }

                &.selected {
                    background-color: $green;

                    .check-icon {
                        display: block;
                        i {
                            display: block;
                            color: #fff;
                            font-size: 13px;
                        }
                    }
                }
            }

            
        }
    }

    &__certificate-instructions {
        padding: 16px;
        border-radius: 8px;
        display: flex;
        gap: 10px;
        
        i {
            font-size: 24px;

            &.error {
                color: map-get($secondary, 500);
            }
        }
        p {
            font-size: 10px;
            
            &.error {
                color: map-get($secondary, 500);
            }
        }
    }

    .upload-file__container{
        #upload-file{
            visibility: hidden;
            position: absolute;
            width: 0px;
            height: 0px;
            top: 0;
            left: 0;
        }
        label{
            padding: 11px 14px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 4px;
            border: 1px solid $green;
            border-radius: 44px;
            color: $green;
            font-size: 15px;
            font-weight: 600;
            cursor: pointer;
            width: 100%;
            .material-icons{
                color: $green;
                font-size: 22px;
            }
        }

        .disabled{
            background-color: #f5f5f5;
            color: #C4C4C4;
            border: 1px solid #C4C4C4;
            cursor: not-allowed;
        }
    }

    .uploaded-file__pill {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px;
        border: 1px solid $green;
        border-radius: 100px;
        color: $green;
        font-size: 14px;

        i {
            cursor: pointer;
        }

        &.requirements-not-met {
            border-color: #F57055;
            color: #F57055;
        }
    }

    .modal__buttons {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
    }
}
.modal-you-sure {
    display: flex;
    flex-direction: column;
    gap: 16px;
    text-align: center;
    max-width: 500px;

    h4 {
        font-weight: 600;
        font-size: 18px;

        strong {
            color: $green;
        }
    }

    p {
        font-size: 16px;
        font-weight: 400;
    }

    .modal__buttons {
        display: flex;
        justify-content: center;
        gap: 24px;

        button {
            width: unset;
            padding: 8px 24px;

            .cancel {
                color: $green;
                border: none!important;
            }
            .confirm {
                padding: 8px 24px;
                border-radius: 100px;
            }
        }
    }
}
</style>
